import { render, staticRenderFns } from "./paymentSuccessful.vue?vue&type=template&id=63f5281c&scoped=true"
import script from "./paymentSuccessful.vue?vue&type=script&lang=js"
export * from "./paymentSuccessful.vue?vue&type=script&lang=js"
import style0 from "./paymentSuccessful.vue?vue&type=style&index=0&id=63f5281c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f5281c",
  null
  
)

export default component.exports